<template>
  <div class="container">
    <div class="logoBox">
      <img :src="logo" alt="印先森" />
    </div>
    <div class="explainAndDownload">
      <div class="text">
        <p>下载App:</p>
        <p>1、应用宝/华为/小米/vivo/OPPO/苹果等应用商店,搜索“印先森”进行下载</p>
        <p>2、直接点击下方对应系统的按钮进行下载</p>
      </div>
      <a href="https://apps.apple.com/cn/app/id1438491469">
        <img :src="iPhoneDownload" />
        <!-- <span class="versionSpan">支持IOS 12.0以上</span> -->
      </a>
      <a :href="apkUrl">
        <img :src="androidDownload" />
        <!-- <span class="versionSpan">支持安卓 8.0以上</span> -->
      </a>
    </div>
    <div class="instructionsBox">
      <p>产品说明书：</p>
      <a
        href="http://downloadapp.qu-in.com/manual/mseries/mrin/zh-cn/index.html"
        >http://downloadapp.qu-in.com/manual/mseries/mrin/zh-cn/index.html</a
      >
    </div>
    <!-- <div class="qrCodeImg">
      <img :src="QRcode" alt="二维码" />
      <p>长按扫描二维码</p>
      <p>关注公众号，领取专属福利</p>
    </div> -->
  </div>
</template>

<script>
import QRcode from "../../assets/QRcode.png";
import androidDownload from "../../assets/androidDownload.png";
import iPhoneDownload from "../../assets/iPhoneDownload.png";
import logo from "../../assets/LOGO.png";
import { getAndroidLink } from "@/api/home";

export default {
  name: "home",
  data() {
    return {
      QRcode,
      androidDownload,
      iPhoneDownload,
      logo,
      apkUrl:"https://quyin.oss-cn-shenzhen.aliyuncs.com/apk/Mr_in.apk"
      // "http://www.qu-in.com/download/M02APP.html",
    };
  },
  methods: {
    getAndroidLink() {
      getAndroidLink().then((res) => {
        this.apkUrl = res.apkUrl;
      });
    },
  },
  created() {
    this.getAndroidLink();
  },
};
</script>

<style lang="less" scoped src="./index.less" />


// WEBPACK FOOTER //
// src/view/home/index.vue